"use client"
import { iconsMap } from "@/public/icons/iconsMap"
import styled from "@emotion/styled"
import { Dialog, IconButton } from "@mui/material"
import { ReactNode } from "react"
import { mediaQueries } from "../theme/mediaQueries"

type Props = {
  handleClose: any
  open: boolean
  children: ReactNode
  className?: string
}

const StyledDiv = styled.div``

const StyledDialog = styled(Dialog)`
  z-index: 10;
  .MuiPaper-root {
    width: 100%;
    height: auto;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    padding-top: 50px;
    padding-bottom: 80px;
    margin: 0;
    ${mediaQueries.tablet} {
      height: 100%;
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }
  .MuiDialog-container {
    ${mediaQueries.tabletDown} {
      align-items: flex-start;
    }
  }
  ${mediaQueries.tablet} {
    .MuiPaper-root {
      width: 888px;
      height: 579px;
    }
    p {
      max-width: 400px;
    }
  }
`
const StyledCloseButton = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 11;
  ${mediaQueries.tabletDown} {
    button {
      padding: 0px;
    }
  }
`

const CustomDialog = ({ open, handleClose, children, className }: Props) => {
  const CloseIcon = iconsMap.closeIcon
  return (
    <StyledDiv>
      <StyledDialog open={open} onClose={handleClose} className={className}>
        <StyledCloseButton>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </StyledCloseButton>
        {children}
      </StyledDialog>
    </StyledDiv>
  )
}

export default CustomDialog
